<template>
  <div>
    <div>我是一个模版组件看着我改造即可;</div>
    <div class="margin_container">
      <div
        v-for="(item, index) in margin"
        :key="index"
        class="margin_box"
      >
        <el-input
          v-model="margin[index]"
          width="32px"
          :data-index="index"
        />
        <div class="margin_box_text">
          {{ margin_index[index] }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import mixin from '@/view/weappTmp/core/lib/package/element-node-mixin.js'
export default {
  name: 'FormTmp',
  mixins: [mixin],
  data () {
    return {
      margin_index: ['上', '右', '下', '左'],
      margin: [0, 0, 0, 0]
    }
  },
  watch: {},
  created () {},
  methods: {}
}
</script>
<style scoped lang="scss">
.margin_container {
  display: flex;
}
.margin_box {
  margin-right: 8px;
  text-align: center;
  .margin_box_text {
    margin-top: 4px;
  }
}
</style>
